import React, { Component } from 'react';

export default class Notification extends Component {

    getColor() {
        if(!this.props.data || !this.props.data.hasOwnProperty('type')) return;
        switch(this.props.data.type) {
            case 'warning':
                return '#AA3F1D';
            default:
                return '#38B08C';
        }
    }

    render() {
        const style = {
            pointerEvents: 'none',
            position: 'fixed',
            top: 0,
            left: this.props.data && this.props.data.isShowing ? 0 : -20,
            height: 42,
            fontWeight: 400,
            transition: 'all .3s ease-in-out',
            backgroundColor: this.getColor(),
            padding: '13px 30px',
            color: 'rgba(255,255,255,0.8)',
            opacity: this.props.data && this.props.data.isShowing ? 1 : 0,
            zIndex: 999,
            boxSizing: 'border-box',
        };

        return (
            <div style={style}>{ this.props.data ? this.props.data.message : null }</div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Notification.js